import React from 'react';
import CommissionForm from './CommissionForm';

const SecondaryContent = () => {
  return <CommissionForm />;
};

export default React.memo(SecondaryContent);
